import transport from "core/model/api/transport";
import {
  PendingSealdAccess,
  RCryptoKey,
  SealdAccessPayload,
  SessionKey,
} from "core/types";

export default {
  checkSealdGroupAccess(payload: {
    careprovider_id?: number;
    careseeker_id?: number;
  }): Promise<{ exists: boolean }> {
    return transport.post({
      body: payload,
      options: {
        routeName: "checkSealdGroupAccess",
      },
      route: `/seald/group/check`,
    });
  },
  createSealdAccess(sealdAccess: Partial<SealdAccessPayload>): Promise<null> {
    return transport.post({
      body: sealdAccess,
      options: {
        routeName: "createSealdAccess",
      },
      route: `/seald/access/create`,
    });
  },
  getPendingKeys(): Promise<any> {
    return transport.get({
      options: {
        routeName: "getPendingKeys",
      },
      route: `/crypto/pending`,
    });
  },
  getPendingSealdAccess(): Promise<PendingSealdAccess[] | null> {
    return transport.get({
      options: {
        routeName: "getPendingSealdAccess",
      },
      route: `/seald/access/pending`,
    });
  },
  postKeys(
    accountId: number,
    cryptoKeys: RCryptoKey,
    token: string,
  ): Promise<any> {
    return transport.post({
      body: {
        ...cryptoKeys,
        account_id: accountId,
      },
      options: { routeName: "postKeys", token },
      queryParams: null,
      route: `/crypto/account/${accountId}`,
    });
  },
  updateEncryptedPrivateKey(
    accountId: number,
    cryptoKeys: { private_key_fivek: string },
    token: string,
  ): Promise<any> {
    return transport.put({
      body: {
        account_id: accountId,
        ...cryptoKeys,
      },
      options: { routeName: "updateKeys", token },
      queryParams: null,
      route: `/crypto/account/${accountId}`,
    });
  },
  updatePendingSessionKey(key: SessionKey): Promise<any> {
    return transport.put({
      body: key,
      queryParams: {
        routeName: "updatePendingKeys",
      },
      route: `/crypto/pending`,
    });
  },
};
